import React, { useState, useCallback, useRef, useEffect, ChangeEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { createModeratorComment } from '../../../services/moderatorComments';
import { ModeratorCommentRequest } from '../../../types/api/comments';
import ModalSheet from '../../basic/ModalSheet';
import { Stack, Textarea, FormControl, Button } from '@primer/react'

interface CreateAdsCommentModalProps {
    adIds: string[]
    isOpen: boolean;
    onDidCommentSended: () => void;
    onClose: () => void;
}

export const CreateAdsCommentModal: React.FC<CreateAdsCommentModalProps> = ({ adIds, isOpen, onDidCommentSended, onClose }) => {

    const [commentText, setCommentText] = useState<string>('');
    const [isPending, setIsPending] = useState<boolean>(false)

    const handleCommentChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
        setCommentText(e.target.value);
    }, []);

    const { mutate: sendComment } = useMutation({
        mutationFn: ({ request }: {
            request: ModeratorCommentRequest,
        }) => createModeratorComment(request)
    });

    const createCommentsForAll = () => {
        if (adIds.length === 0) return;

        setIsPending(true);

        const promises = adIds.map(id => {
            const data: ModeratorCommentRequest = {
                entityId: id,
                content: commentText,
                entityType: "ad"
            };

            return new Promise((resolve, reject) => {
                sendComment(
                    { request: data },
                    {
                        onSuccess: (data) => resolve(data),
                        onError: (error) => reject(error),
                    }
                );
            });
        });

        Promise.all(promises)
            .then(() => {
                setIsPending(false);
                onDidCommentSended();
            })
            .catch(() => {
                setIsPending(false);
            });
    };

    return (
        <ModalSheet
            isOpen={isOpen}
            onClose={onClose}
            title="Комментарий к блокировке"
            size="middle"
            headerSize="regular"
        >
            {({ setTitle }) => (
                <Stack className='mt-[16px]'>
                    <FormControl>
                        <FormControl.Label className='invisible'></FormControl.Label>
                        <Textarea
                            value={commentText}
                            resize="none"
                            cols={60}
                            rows={10}
                            maxLength={1000}
                            contrast={!!(commentText && commentText.trim())}
                            onChange={handleCommentChange}

                        />
                    </FormControl>

                    <Stack direction="horizontal" gap='normal' justify='end'>
                        <div></div>
                        <Button
                            onClick={createCommentsForAll}
                            size='small'
                            variant="primary"
                            loading={isPending}
                            disabled={isPending || !commentText.trim() || commentText.trim().length > 1000}>
                            Отправить
                        </Button>
                    </Stack>
                </Stack>
            )}
        </ModalSheet>
    );
};